import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UiRoutes {
    public static readonly AgingReport = 'reports/aging';
    public static readonly ApiTokens = 'tokens';
    public static readonly Backend = 'backend';
    public static readonly Claims = 'claims';
    public static readonly ResetPassword = 'reset-password';
    public static readonly Endpoints = 'endpoints';
    public static readonly FeatureFlags = 'feature-flags';
    public static readonly Health = '_healthz';
    public static readonly Home = '';
    public static readonly Local = 'local';
    public static readonly LocalClaims = 'claims';
    public static readonly LocalBackend = 'backend';
    public static readonly Login = 'login';
    public static readonly Logout = 'logout';
    public static readonly Logs = 'logs';
    public static readonly NotFound = 'not-found';
    public static readonly NotSupported = 'not-supported';
    public static readonly Redirect = 'redirect';
    public static readonly SelectCompany = 'select-company';
    public static readonly Settings = 'settings';
    public static readonly Wildcard = '**';
}

@Injectable({ providedIn: 'root' })
export class UiRouteParams {
    public static readonly LogKey = ':logKey';
}

@Injectable({ providedIn: 'root' })
export class UiRouteLinks {
    public static ResetPassword = `/${UiRoutes.ResetPassword}`;
    public static Health = `/${UiRoutes.Health}`;
    public static Login = `/${UiRoutes.Login}`;
    public static Logout = `/${UiRoutes.Logout}`;
    public static NotFound = `/${UiRoutes.NotFound}`;
    public static SelectCompany = `/${UiRoutes.SelectCompany}`;
}

@Injectable({ providedIn: 'root' })
export class TitleConstants {
    public static CoreSiteTitle = 'LSQ';
    public static CoreSiteTitleSuffix = ' - ' + TitleConstants.CoreSiteTitle;
}
